import { createStore } from '../../lib/create-store';

import { getActions, getInitialState, getReducer } from '.';

const ACTION_PREFIX = 'BANNER_BOTTOM';

const initialState = getInitialState();
const reducer = getReducer(ACTION_PREFIX);

export const slimBannerBottomStore = createStore({
  name: 'slimBannerBottomStore',
  initialState,
  reducer,
});

export const slimBannerBottomActions = getActions(ACTION_PREFIX);
